// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Sidebar-module--toggle--R-W59","sidebar":"Sidebar-module--sidebar--S10e9","link":"Sidebar-module--link--15S0m","button":"Sidebar-module--button--mrpt-"};